/* BRV-111 — Newsletter sticky bottom-sheet + deferred popup logic.
   Sticky: shows after 6s (not blocking, gentle).
   Popup (Wave 1 welcome): deferred to exit-intent OR 30s+ no interaction.
   Both capped 7d via cookie. GA4 events: newsletter_signup_sticky / _popup. */
(function(){
  var STICKY_KEY = 'brava_news_sticky_dismissed';
  var POPUP_KEY = 'brava_news_popup_seen';
  var STICKY_ARM_MS = 6000;
  var POPUP_DEFER_MS = 30000;

  function getCookie(name){
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]+)'));
    return m ? m[1] : null;
  }
  function setCookie(name, val, days){
    var d = new Date();
    d.setTime(d.getTime() + days*86400000);
    document.cookie = name + '=' + val + ';path=/;expires=' + d.toUTCString() + ';samesite=lax';
  }

  // STICKY
  var sticky = document.querySelector('[data-news-sticky]');
  if (sticky && !getCookie(STICKY_KEY)) {
    setTimeout(function(){
      sticky.hidden = false;
      sticky.offsetHeight; // reflow
      sticky.classList.add('is-armed');
    }, STICKY_ARM_MS);

    var openBtn = sticky.querySelector('[data-news-open]');
    var panel = sticky.querySelector('.news-sticky__panel');
    var closeBtn = sticky.querySelector('[data-news-close]');

    if (openBtn && panel) {
      openBtn.addEventListener('click', function(){
        var expanded = sticky.getAttribute('data-expanded') === '1';
        if (expanded) {
          panel.hidden = true;
          sticky.setAttribute('data-expanded', '0');
          openBtn.setAttribute('aria-expanded', 'false');
        } else {
          panel.hidden = false;
          sticky.setAttribute('data-expanded', '1');
          openBtn.setAttribute('aria-expanded', 'true');
        }
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function(){
        sticky.classList.remove('is-armed');
        setTimeout(function(){ sticky.hidden = true; }, 260);
        setCookie(STICKY_KEY, '1', 7);
      });
    }

    var submit = sticky.querySelector('[data-news-submit]');
    if (submit) {
      submit.addEventListener('click', function(){
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'newsletter_signup_sticky',
            discount_code: 'BRAVA10'
          });
        }
        setCookie(STICKY_KEY, '1', 30);
      });
    }
  }

  // DEFERRED POPUP — only if deferral setting is on and Wave 1 popup is off
  // We piggyback on the existing wave-1 popup container (.js-popup) and re-trigger after delay/exit-intent.
  function isDeferredOn(){
    return !!document.querySelector('[data-news-sticky]'); // proxy: if the sticky exists, deferral is intended
  }
  if (isDeferredOn() && !getCookie(POPUP_KEY)) {
    var popupEl = document.querySelector('.js-popup');
    if (popupEl) {
      var popupShown = false;
      function tryShowPopup(reason){
        if (popupShown) return;
        popupShown = true;
        // Lazy-trigger by setting cookie that Wave 1's Popup module checks
        document.cookie = 'popupShown=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT'; // clear so it'll show
        popupEl.style.display = 'block';
        var overlay = document.querySelector('.js-popup-overlay');
        if (overlay) overlay.classList.add('is-visible');
        setCookie(POPUP_KEY, '1', 7);
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'newsletter_signup_popup',
            trigger: reason
          });
        }
      }
      // Exit-intent on desktop
      var armExit = false;
      setTimeout(function(){ armExit = true; }, 8000);
      document.addEventListener('mouseleave', function(e){
        if (armExit && e.clientY < 8) tryShowPopup('exit-intent');
      });
      // 30s no-interaction fallback
      var inactivityTimer = setTimeout(function(){ tryShowPopup('30s'); }, POPUP_DEFER_MS);
      ['scroll','keydown'].forEach(function(evt){
        window.addEventListener(evt, function(){
          clearTimeout(inactivityTimer);
          inactivityTimer = setTimeout(function(){ tryShowPopup('30s-idle'); }, POPUP_DEFER_MS);
        }, { passive: true, once: false });
      });
    }
  }
})();
